module.exports = __webpack_public_path__ + "static/media/wanderer-bracelets-7.a6ab2194.jpg";